import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import type { BooleanFilterState } from '../../../../../common/constants/filters/boolean-filter/types';
import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter/create-boolean-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Confluence];

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('onlyTitleMatch');

export const filter: Readonly<{
	id: 'onlyTitleMatch';
	type: 'boolean';
	queryParams: {
		key: string;
		getState: (
			queryParams: Record<string, string[]>,
			cloudId: string,
		) => BooleanFilterState<'onlyTitleMatch'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'onlyTitleMatch'>;
	getInitialState: (
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'onlyTitleMatch'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createBooleanFilter({
	id: 'onlyTitleMatch',
	queryParams: { key: 'titleMatch' },
	products: [...productKeys1P, ...products3PFromConfig],
	alwaysVisible: true,
	universal: false,
});
